import createReducer from "Common/reducerUtils/createReducer";
import set from "Common/reducerUtils/set";
import keyBy from "lodash/keyBy";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
export const initialState = {
    [NAMESPACE]: {
        data: undefined
    }
};
export default createReducer(initialState, {
    [actionTypes.GET_PASSWORD_POLICY_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data`, keyBy(payload, "Type")),
    [actionTypes.SAVE_PASSWORD_POLICY_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].data`, keyBy(payload, "Type"))
});
